<template>
  <div id="app" :class="{ isPc: platform.isPc }">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      version: ''
    }
  },
  methods: {
    // 比较手机版本号方法
    //假定字符串的每节数都在5位以下
    toVersion(version) {
      var newVersion = version.toString()
      //也可以这样写 var c=a.split(/\./);
      var c = newVersion.split('.')
      var num_place = ['', '0', '00', '000', '0000'],
        r = [...num_place].reverse()
      for (var i = 0; i < c.length; i++) {
        var len = c[i].length
        c[i] = r[len] + c[i]
      }
      var res = c.join('')
      return res
    }
  },
  mounted() {
    var UA = navigator.userAgent
    console.log('UA:', UA)
    if (
      UA.indexOf('yixinliApp') >= 0 ||
      UA.indexOf('yixinliConsultationApp') >= 0
    ) {
      this.version = UA.split('yixinliApp;')[1]
      if (this.toVersion(this.version) >= this.toVersion('5.3.5')) {
        localStorage.setItem('version', 'true')
      } else {
        localStorage.setItem('version', 'false')
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  max-width: 10rem;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// App.vue?781135c1